angular.module('pl-shared')
  .filter('imgPath', function(i18ng) {

    return function(path, app) {
      if (!app) app = 'shared'
      return '/static/' + app + '/images/' + i18ng.t(path)
    }

  })
